import React, { useEffect, useState } from 'react'
import Select from 'meinian-package/src/baseComponent/select'
import { findItemByValue } from 'meinian-package/src/baseComponent/select/util'
import request from 'meinian-package/src/utils/request'

const convert = (result) => {
  const all = []
  result.forEach((item) => {
    let parent = null
    parent = { label: item.first.name, value: item.first.id, node: 1 }
    let children = null
    if (item.second && item.second.length) {
      children = item.second.map(son => ({
        label: son.name,
        value: son.id,
        parent,
        node: 2
      }))
      parent.children = children
    }
    all.push(parent)
  })
  all.unshift({ label: '全部', value: null, node: 1 })
  return all
}
export default (props) => {
  const { placeholder = '全部', value, onChange, ...otherProps } = props
  const [options, setOptions] = useState([])
  useEffect(() => {
    fetchCategories()
  }, [])
  const fetchCategories = async () => {
    try {
      const res = await request.get('/v1-5-1/hot/hot-taobao-category?')
      setOptions(convert(res))
    } catch (err) {
      console.error(err)
    }
  }
  const changeID = (_value) => {
    const selectOption = findItemByValue(_value, options)
    if (!selectOption?.children) {
      const parentId = selectOption?.parent.value
      const categoryId = selectOption?.value
      onChange(parentId, categoryId)
    } else {
      const parentId = selectOption?.value
      onChange(parentId)
    }
  }
  return <Select.Cascade
    placement="bottomRight"
    {...otherProps}
    data={options}
    value={value}
    onChange={changeID}
    defaultLeftValue={options.find(m => m?.value === value)?.value
       || findItemByValue(value, options)?.parent?.value || options.find(m => m?.value)?.value}
    placeholder={placeholder}
    multi={false}
    hiddenSelected
    allowClear={false}
    hiddenSearch
    onlyShowLeaf
    rootSelectable
  />
}
